/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Group_WrapupInputs */



/**
* | output |
* | --- |
* | "Wrap up" |
*
* @param {Tools_Group_WrapupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_group_wrapup = /** @type {((inputs?: Tools_Group_WrapupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Group_WrapupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clôture")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cierre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encerramento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiusura")
	return /** @type {LocalizedString} */ ("Wrap up")
});